import { createFileRoute } from '@tanstack/react-router';
import { HierarchyPage, type HierarchyFocus } from '@/features/workforce/hierarchy/HierarchyPage';

const FOCUS: readonly HierarchyFocus[] = ['without-manager', 'manager-inactive'];

export const Route = createFileRoute('/_app/organization/hierarchy')({
  component: HierarchyRoute,
  /* `?focus=` apre la pagina sull'elenco da sistemare: ci arriva l'allarme del menu. */
  validateSearch: (s: Record<string, unknown>): { focus?: HierarchyFocus } =>
    (FOCUS.includes(s.focus as HierarchyFocus) ? { focus: s.focus as HierarchyFocus } : {}),
});

function HierarchyRoute() {
  return <HierarchyPage focus={Route.useSearch().focus} />;
}

/*
 * Gerarchia HR: la reporting line del tenant, in albero e in organigramma, con le azioni per
 * persona (sottoposti, successione, sostituzioni/deleghe, rimozione) e le due globali.
 *
 * Il componente sta in `features/workforce/hierarchy/`, dove vive il dominio: la rotta è solo
 * il punto di ingresso, e desktop e telefono usano lo stesso componente responsivo.
 */
